import { ConfirmUserFormValues } from "./types";

export const initialValues: ConfirmUserFormValues = {
  code: "",
};

export const CODE_LENGTH = 6;
